export default __webpack_public_path__ + "static/media/Flag_of_Malta.b79fa1e8.svg";